import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class WebhookTopicHdrQueryCriteriaClass extends BaseCriteriaModel {
  //bl_webhook_topic_hdr table
  guid?: Optional<string> = Optional.empty();
  topic_code?: Optional<string> = Optional.empty();
  topic_name?: Optional<string> = Optional.empty();
  topic_description?: Optional<string> = Optional.empty();
  created_date?: Optional<string> = Optional.empty();
  updated_date?: Optional<string> = Optional.empty();

}

export class WebhookTopicHdrCriteriaModelQuery {
  query = '';

  constructor(WebhookTopicHdrCriteriaModel: WebhookTopicHdrQueryCriteriaClass) {

    if (!WebhookTopicHdrCriteriaModel) {
      return;
    }

    this.query += WebhookTopicHdrCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += WebhookTopicHdrCriteriaModel.topic_code.filter(x => x !== '').map(x => '&topic_code=' + x).orElse('');
    this.query += WebhookTopicHdrCriteriaModel.topic_name.filter(x => x !== '').map(x => '&topic_name=' + x).orElse('');
    this.query += WebhookTopicHdrCriteriaModel.topic_description.filter(x => x !== '').map(x => '&topic_description=' + x).orElse('');
    this.query += WebhookTopicHdrCriteriaModel.created_date.filter(x => x !== '').map(x => '&created_date=' + x).orElse('');
    this.query += WebhookTopicHdrCriteriaModel.updated_date.filter(x => x !== '').map(x => '&updated_date=' + x).orElse('');

    this.query += '&status=' + WebhookTopicHdrCriteriaModel.status;
    this.query += '&orderBy=' + WebhookTopicHdrCriteriaModel.orderBy;
    this.query += '&order=' + WebhookTopicHdrCriteriaModel.order;
    this.query += '&offset=' + WebhookTopicHdrCriteriaModel.offset + '&limit=' + WebhookTopicHdrCriteriaModel.limit;
  }
}
